import React from "react";
import { useNavigate } from "react-router-dom";
import ChicagoRegattaBanner from "../images/chicago_regatta_banner.jpg";
import ChicagoRegattaCup from "../images/chicago_regatta_cup.png";

const ImageCluster = () => {
  const navigate = useNavigate();

  return (
    <div className="image-container">
      <img
        alt="Chicago Regatta Banner"
        src={ChicagoRegattaBanner}
        className="image-cluster-top"
        onClick={() => navigate("/")}
      />
      <img
        alt="Chicago Regatta Cup"
        src={ChicagoRegattaCup}
        className="image-cluster-bottom"
      />
    </div>
  );
};

export default ImageCluster;
